import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {BehaviorSubject, Observable, of} from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import {BulkRecruiter, RecruiterList, RecruiterStudy} from '../../recruiters/model/recruiter.model';
import {environment} from '../../../environments/environment';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';



@Injectable({
  providedIn: 'root'
})
export class RecruiterServices {


  /**
   * Auther: Praveen Kumar
   * Description : All the services's method of recruiter functionality.
   * */

  //  GET_ALL_COUNTRY = environment.apiUrl + '/v2/country/recruiter';
  //  GET_ALL_RECRUITER = environment.apiUrl + '/v2/recruiters';
  //  BULK_RECRUITER_UPLOAD = environment.apiUrl + '/v2/recruiters';
  //  GET_STUDY_RECRUITER = environment.apiUrl + '/v2/study/recruiters';
  //  ADD_RECRUITER = environment.apiUrl + '/v2/recruiter';
  //  UPDATE_RECRUITER = environment.apiUrl + '/v2/recruiter/';
  //  UPDATE_RECRUITER_STATUS = environment.apiUrl + '/v2/recruiter';
  //  GET_RECRUITER_ID = environment.apiUrl + '/v2/recruiter';
  //  ADD_REMOVE_STUDY_RECRUITER = environment.apiUrl + '/v2/recruiter/study/active_remove';
  //  GET_ALL_RECRUITER_BY_KEYWORD = environment.apiUrl + '/v2/search/recruiters';
   
  //  GET_GLOBAL_SEARCH= environment.apiUrl + '/v2/api/globalsearch';

  GET_ALL_COUNTRY = '/v2/country/recruiter';
  GET_ALL_RECRUITER = '/v2/recruiters';
  BULK_RECRUITER_UPLOAD = '/v2/recruiters';
  GET_STUDY_RECRUITER = '/v2/study/recruiters';
  ADD_RECRUITER = '/v2/recruiter';
  UPDATE_RECRUITER = '/v2/recruiter';
  UPDATE_RECRUITER_STATUS = '/v2/recruiter';
  GET_RECRUITER_ID = '/v2/recruiter';
  ADD_REMOVE_STUDY_RECRUITER = '/v2/recruiter/study/active_remove';
  GET_ALL_RECRUITER_BY_KEYWORD = '/v2/search/recruiters';
  
  GET_GLOBAL_SEARCH= '/v2/api/globalsearch';




  /*
  * Managing Store for Recruiter related Task
  * */

  private _recruiters: BehaviorSubject<RecruiterList[]>;
  private dataStore: {  // This is where we will store our data in memory
    recruiters: RecruiterList[]
  };
  get RecruiterData(){
    return this._recruiters.asObservable();
  }


  constructor(private http: HttpClient, private apiRequest: ApiRequestService) {
    this.dataStore = { recruiters: [] };
    this._recruiters = <BehaviorSubject<RecruiterList[]> > new BehaviorSubject([]);
  }

  // Header for authentication
  httpPostOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json'),
    params: new HttpParams(),
    withCredentials: true
  };

  //Header Authentication for file type request
  httpPostOptionsBulk = {
      withCredentials: true
  };


  loadRecruiter() {
    let pathUrl = this.GET_ALL_RECRUITER + '?pageLimit=1000'
    return this.apiRequest.request('GET',pathUrl).pipe(map(data => {
      let _data:any = data;
      return _data;
    })).subscribe(data => {
      this.dataStore.recruiters = data;
      this._recruiters.next(Object.assign({}, this.dataStore).recruiters);
    }, error => {
      // console.error('There is some error to load all recruiters')
    });
    // this.http.get<any>(this.GET_ALL_RECRUITER + '?pageLimit=1000', this.httpPostOptions).subscribe(data => {
    //   this.dataStore.recruiters = data;
    //   this._recruiters.next(Object.assign({}, this.dataStore).recruiters);
    // }, error => {
    //   // console.error('There is some error to load all recruiters')
    // });
  }



  getAllRecruiter( ) {
    let pathUrl = this.GET_ALL_RECRUITER + '?pageLimit=1000'
    return this.apiRequest.request('GET',pathUrl).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.get<RecruiterList>(this.GET_ALL_RECRUITER + '?pageLimit=1000', this.httpPostOptions);
  }
  
  getAllCountry( ) {
    return this.apiRequest.request('GET',this.GET_ALL_COUNTRY);
    // return this.http.get<any>(this.GET_ALL_COUNTRY, this.httpPostOptions);
  }

   getAllRecruiterBykeyword(keyword,type) {
     let pathUrl = this.GET_GLOBAL_SEARCH+'?parameter='+keyword+'&type='+type
    return this.apiRequest.request('GET',pathUrl).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.get<RecruiterList>(this.GET_GLOBAL_SEARCH+'?parameter='+keyword+'&type='+type, this.httpPostOptions);

  }


  getGlobalSearch(keyword) {
    let pathUrl = this.GET_GLOBAL_SEARCH+'?parameter='+keyword
    return this.apiRequest.request('GET',pathUrl).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.get<RecruiterList>(this.GET_GLOBAL_SEARCH+'?parameter='+keyword, this.httpPostOptions);
  }

  getPaginationRecruiter( pageData:any) {
    const GET_RECRUITER = '/v2/recruiters?pageNo=' + pageData['pageNo'] + '&pageLimit=' + pageData['pageLimit'];
    let pathUrl = GET_RECRUITER
    return this.apiRequest.request('GET',pathUrl).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.get<RecruiterList>(GET_RECRUITER, this.httpPostOptions);
  }

  getRecruiterById( id:any) {
    let pathUrl = this.GET_RECRUITER_ID +'/'+ id
    return this.apiRequest.request('GET',pathUrl);
    // return this.http.get<any>(this.GET_RECRUITER_ID +'/'+ id, this.httpPostOptions);
  }

  bulkUploadRecruiter ( csv) {
    let input = new FormData();
    input.append('file', csv, csv.name);

    let opt = {};
    opt['httpOptions'] = this.httpPostOptionsBulk
    return this.apiRequest.request('POST',this.BULK_RECRUITER_UPLOAD,input,opt).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.BULK_RECRUITER_UPLOAD, input, this.httpPostOptionsBulk);

  }

  addRecruiter(recruiter) {
    return this.apiRequest.request('POST',this.ADD_RECRUITER,recruiter).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.ADD_RECRUITER, recruiter, this.httpPostOptions);
  }
  updateRecruiter(id, payload){
    let pathUrl = this.UPDATE_RECRUITER + '/' + id
    return this.apiRequest.request('PUT',pathUrl,payload).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.put<any>(this.UPDATE_RECRUITER+id,payload,this.httpPostOptions);
  }
  getSpecificRecruiter(id, pageData:any) {
    let pathUrl = this.GET_STUDY_RECRUITER + '/' + id + '?pageNo=' + pageData['pageNo'] + '&pageLimit=' + pageData['pageLimit']
    return this.apiRequest.request('GET',pathUrl).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.get<any>(this.GET_STUDY_RECRUITER + '/' + id + '?pageNo=' + pageData['pageNo'] + '&pageLimit=' + pageData['pageLimit'], this.httpPostOptions);
  }

  addRemoveStudyRecruiter(study, recruiter, status) {
    let body = {study: study, recruiter_id: recruiter, status: status}
    return this.apiRequest.request('POST',this.ADD_REMOVE_STUDY_RECRUITER,body);
    // return this.http.post<any>(this.ADD_REMOVE_STUDY_RECRUITER, {study: study,
    //    recruiter_id: recruiter, status: status}, this.httpPostOptions);
  }
  updateRecruiterStatus(recruiter, status) {
    let pathUrl = this.UPDATE_RECRUITER_STATUS + '/' + recruiter
    return this.apiRequest.request('PUT',pathUrl,{ status: status});
    // return this.http.put<any>(this.UPDATE_RECRUITER_STATUS + '/' + recruiter, { status: status}, this.httpPostOptions);
  }
}

